import React, { useState} from "react";
import { Helmet } from "react-helmet-async";
import "./Cybersoul.css";

const Cybersoul = () => {
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const apiKey = process.env.REACT_APP_API_KEY;
  const apiUrl = "https://api.openai.com/v1/chat/completions";

  // 📥 ارسال پیام و تصویر (در صورت وجود) به OpenAI
  const fetchAIResponse = async (userInput) => {
    try {

      const messagesPayload = [
        { role: "system", content: "You are Lia, an AI created by LiaLab." },
        { role: "user", content: userInput }
      ];

      const body = {
        model: "gpt-4o",
        messages: messagesPayload
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiKey}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.choices[0].message.content;
    } catch (error) {
      console.error("Error fetching AI response:", error);
      return "Error: Could not fetch AI response.";
    }
  };

  // 🎯 ارسال پیام
  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedInput = inputValue.trim();
    if (trimmedInput === "" ) return;

    setMessages((prevMessages) => [
      ...prevMessages,
      { text: trimmedInput || "Image uploaded", user: true },
    ]);

    const aiResponse = await fetchAIResponse(trimmedInput);
    setMessages((prevMessages) => [
      ...prevMessages,
      { text: aiResponse, user: false },
    ]);

    setInputValue("");
  };

  return (
    <>
      <Helmet>
        <title>Lia | Lia AI</title>
      </Helmet>
        <div className="cybersoul-container">
          <div className="chat-container">
            <div className="message-list">
              {messages.map((message, index) => (
                <div key={index} className={`message ${message.user ? "user" : "ai"}`}>
                  <div className="message-content">{message.text}</div>
                </div>
              ))}
            </div>

            {/* 🔹 فرم چت */}
            <form onSubmit={handleSubmit} className="input-form">
              <textarea rows="2" value={inputValue} onChange={(e) => setInputValue(e.target.value)} placeholder="Type your message..." />
              <button type="submit">Send</button>
            </form>
          </div>
        </div>
    </>
  );
};

export default Cybersoul;
